import axios from "axios";
import {ElMessage, ElLoading} from "element-plus";
// 创建 axios 实例
const TIME_OUT = 15000
let timeOutTimer = {}
// let service = window.$_axios
let errNoticeLock = false; // 避免多个弹窗
const baseConfig = [import.meta.env.VITE_APP_BASE_API, import.meta.env.VITE_APP_FILE_API];

// if (!service) {
let service = axios.create({
  baseURL: import.meta.env.VITE_APP_BASE_API,
  timeout: TIME_OUT,
  headers: {"Content-Type": "application/json;charset=utf-8"},
});

// 请求拦截器
service.interceptors.request.use(
  // (config: InternalAxiosRequestConfig) => {
  (config) => {
    // 适配多网关
    let params = window?.$glob?.params || {
      token: localStorage.getItem('accessToken'),
      solutionId: localStorage.getItem('solutionId'),
      tenantId: localStorage.getItem('tenantId'),
    }
    if (params.token) {
      config.headers.Authentication = params.token;
    }
    // config.method = 'post'
    if (params.solutionId) {
      config.headers["X-Solution-Id"] = params.solutionId;
    }

    if (params.tenantId) {
      config.headers["X-Tenant-Id"] = params.tenantId;
    }
    baseConfig.forEach((v) => {
      if (new RegExp("^" + v).test(config.url)) {
        config.baseURL = "/";
      }
    });
    const source = axios.CancelToken.source();
    config.cancelToken = source.token;
    checkRequest(config, source);
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// 响应拦截器
service.interceptors.response.use(
  // (response: AxiosResponse) => {
  (response) => {
    deleteRequestKey(response.config)
    // TODO: 非合理， 需后端统一处理
    if (response.data === "success") return response.data;

    const {code, message, data} = response.data;

    if (code === 200) {
      return data;
    }
    // 响应数据为二进制流处理(Excel导出)
    if (response.data instanceof ArrayBuffer) {
      return response;
    }

    // 是否开启错误通知
    if (!(response.config?.notify ?? true) || errNoticeLock)
      return Promise.reject(new Error(message || 'Error'));

    errNoticeLock = true;
    ElMessage.error({
      message: message || '系统出错',
      duration: 2000,
      onClose: () => {
        errNoticeLock = false;
      }
    });
    // ElMessage.error(message || "系统出错");
    return Promise.reject(new Error(message || "Error"));
  },
  (error) => {
    console.log(error)
    if (axios.isCancel(error)) {
      return new Promise(() => {
      });
    }
    return Promise.reject(error.message);
  },
);
// }
// 以下处理并发重复请求
//创建存储 key 的 集合
let keyMap = new Map();

//获取每一次请求的key
function getRequestKey(config) {
  let {url, baseURL, method, data} = config;
  //记得这里一定要处理 每次请求都掉会变化的参数(比如每个请求都携带了时间戳),否则二个请求的key不一样
  if (typeof data === 'object') {
    data = JSON.stringify(data)
  } else if (typeof data === 'string' && data.indexOf('{') >= 0 && data.indexOf('}') >= 0) {
    data = JSON.stringify(JSON.parse(data))
  }
  url = url.replace(baseURL, '')
  let key = [url, method, data].join("&");
  return key;
}

//判断是否存在该key,不存在则插入
function checkRequest(config, source) {
  let key = getRequestKey(config);
  if (keyMap.has(key)) {
    source.cancel();
  } else {
    keyMap.set(key, config);
    // 超时清除
    timeOutTimer[key] = setTimeout(() => {
      if (keyMap.has(key)) {
        keyMap.delete(key);
      }
      clearTimeout(timeOutTimer[key]);
    }, TIME_OUT)
  }
}

//响应完成后,删除key
function deleteRequestKey(config) {
  let key = getRequestKey(config);
  if (keyMap.has(key)) {
    keyMap.delete(key);
  }
}

export const request = (param) => {
  if (window?.$bs_request) return window.$bs_request(param)
  // 由于全局合并都使用service，而service原本定义的请求是写死的post，导致无法发起get请求，在30行已注释掉。
  // 新逻辑：对默认未写method的请求仍然默认使用post，同时支持自定义method
  if (!param.method) {
    param.method = 'post'
  }
  return service(param)
};
const oacl_url = "/aida-oacl";
const engine_url = "/aida-engine";
const basic_url = "/aida-basic";

// 用户中心 菜单配置
const oacl_menu_url = oacl_url + "/lceResource";
const app_group_url = engine_url + "/groupCount";
const app_service_url = engine_url + "/appService";
const domain_url = engine_url + "/domainService";
const dicItem_url = basic_url + "/dictManagerItem"; // 字典项管理
const dic_url = basic_url + "/dictManager";

export const bizPath = {
  appMenu: oacl_menu_url,
  sceneAppRel: engine_url + "/sceneAppRelation",
  scene: engine_url + "/sceneInfo",
  pageParam: engine_url + "/pageOpenApiDto",
  standerAction: engine_url + "/standardAction",
  appRef: basic_url + "/appReference",
  app: basic_url + "/appManager",
  appService: engine_url + "/appService",
  appExecute: engine_url + "/appExecuteEngine",
  dictItem: dicItem_url, //  dicItem_url
  dict: dic_url, // 字典管理


};
export const commonDao = {
  custRequest: (path, p) => {
    return request({
      url: path,
      data: p,
    });
  },
  list: (path, p) => {
    return request({
      url: path + "/list",
      data: p,
    });
  },
  page: (path, p) => {
    return request({
      url: path + "/pageList",
      data: p,
    });
  },
  add: (path, p) => {
    return request({
      url: path + "/add",
      data: p,
    });
  },
  batchAdd: (path, p) => {
    return request({
      url: path + "/batchAdd",
      data: p,
    });
  },
  edit: (path, p) => {
    return request({
      url: path + "/edit",
      data: p,
    });
  },
  remove: (path, p) => {
    return request({
      url: path + "/del",
      data: p,
    });
  },
  detail: (path, p) => {
    return request({
      url: path + "/getById",
      data: p,
    });
  },
  save: (path, p) => {
    if (p.id) {
      return request({
        url: path + "/edit",
        data: p,
      });
    } else {
      return request({
        url: path + "/add",
        data: p,
      });
    }
  },
};
export const appDao = {
  getBySpaceCode: (p) => request({url: bizPath.app + "/getBySpaceCode", data: p}),
  getCanvas: (p) => request({url: domain_url + "/getCanvasByAppIdVersion", data: p}),
  saveCanvas: (p) => request({url: domain_url + "/saveCanvas", data: p}),
  listBySpaceIdAndType: (p) => request({url: domain_url + "/getBySpaceIdAndType", data: p}),
  getAllDomainAndModel: (p) => request({url: app_service_url + "/getModelListByAppId", data: p}),
  getAppVersion: (p) => request({url: bizPath.app + "/getById", data: p}),
  qryServiceParams: (p) => request({url: app_service_url + "/listParams", data: p}),
  qryAppInfo: (p) => {
    return request({
      url: `${bizPath.app}/getByIdAndVersion`,
      data: p,
    });
  },
};

export const appService = {
  // auto: 自动合并
  execute: (p, cusUrl, auto = true) => {
    let url = bizPath.appExecute + "/executeMethod";
    // 打包环境替换url
    if (window.ID_PATH_MAP) {
      // 数据中台服务写死路径
      if (p.dataModelId || p.type === "dataCount" || p.__flag || p?.paramMap?.__flag || !p.actionId) {
        url = `/${Object.values(window.appCode || {default: ""})[0]}/groupCount/getCountGroupCount`;
      } else {
        url = ID_PATH_MAP[p.actionId];
      }
    }
    if (auto) return comboRequest(cusUrl || url, p);
    else
      return request({
        url: cusUrl || url,
        data: p,
      });
  },
  getParamById: (p) =>
    request({
      url: bizPath.appService + "/getParamById",
      data: p,
    }),
  setParamById: (p) =>
    request({
      url: bizPath.appService + "/setParamById",
      data: p,
    }),
  list: (p) =>
    request({
      url: bizPath.appService + "/list",
      data: p,
    }),
};
export const appMenuDao = {
  getMenus: (p) => {
    return request({
      url: `${bizPath.appMenu}/treeMenu`,
      data: p,
    });
  },
  saveMenus: (p) => {
    return request({
      url: `${bizPath.appMenu}/saveOrUpdate`,
      data: p,
    });
  },
};
export const dictItemDao = {
  getByDictManagerCode: (p) =>
    request({
      url: bizPath.dictItem + "/getByDictManagerCode",
      data: p,
    }),
  getByDictCode: (p) =>
    request({
      url: bizPath.sysDictItem + "/getByDictCode",
      data: p,
    }),
};
// 图表统计接数据中台
export const dataCenterDao = {
  getBizTypes: (p) => {
    return request({
      url: `/aida-engine/dataCenter/getAssetsCategoryList`,
      data: p,
    });
  },
  getModelTypes: (p) => {
    return request({
      url: `/aida-engine/dataCenter/getModellistWithProps`,
      data: p,
    });
  },
  getParams: (p) => {
    return request({
      url: `/aida-engine/dataCenter/getModelPropertyList`,
      data: p,
    });
  },
  getDMList: (p) => {
    return request({
      url: `/aida-engine/dataCenter/getIndexDimList`,
      data: p,
    });
  },
};

export const ruleDataDao = {
  getRefData: (p) => {
    return request({
      url: `${app_group_url}/getRefData`,
      data: p,
    });
  },
};

export const sceneDao = {
  appBindScene: (p) =>
    request({
      url: bizPath.sceneAppRel + "/bindScene",
      data: p,
    }),
  getAppBindScene: (p) =>
    request({
      url: bizPath.sceneAppRel + "/getByAppId",
      data: p,
    }),
  listByAppId: (p) =>
    request({
      url: bizPath.scene + "/listByAppId",
      data: p,
    }),
  savePageOpenApiDtoDto: (p) =>
    request({
      url: bizPath.pageParam + "/savePageOpenApiDtoDto",
      data: p,
    }),
  getByPageId: (p) =>
    request({
      url: bizPath.pageParam + "/getByPageId",
      data: p,
    }),
  getParamsByActionId: (p) =>
    request({
      url: bizPath.standerAction + "/getParamsByActionId",
      data: p,
    }),
};
/***
 * @desc 针对executeMethod接口 增加全局接口组合
 * **/
const _tasks = [];

// 生成随机数
function randomId() {
  let $chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
  let maxPos = $chars.length;
  let id = "";
  for (let i = 0; i < 16; i++) {
    id += $chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return id;
}

// 组合接口
function comboRequest(api, query) {
  return new Promise((resolve, reject) => {
    _tasks.push({
      id: `${query?.name}_${randomId()}`,
      api,
      query,
      resolve,
      reject,
    });
    flushRequestTasks();
  });
}

// 任务刷新
function flushRequestTasks() {
  const limitApiNumber = localStorage.getItem('limitApiNumber') || 100

  if (_tasks.length >= Number(limitApiNumber)) {
    const tasks = _tasks.slice();
    _tasks.length = 0;
    if (!tasks.length) return;
    sendAjax(tasks);
  } else {
    Promise.resolve().then(() => {
      const tasks = _tasks.slice();
      _tasks.length = 0;
      if (!tasks.length) return;
      sendAjax(tasks);
    });
  }
}

// 组合请求
async function sendAjax(tasks) {
  const param = tasks.map((v) => ({id: v.id, query: v.query}));
  let loadingInstance = null
  // aida预览态的判断条件，如果后续不修改class，基本确认唯一
  if (document.querySelector('.preview-page.aida-render')) {
    loadingInstance = ElLoading.service({
      target: '.preview-page.aida-render',
      text: '加载中……',
      customClass: 'aida-full-loading'
    })
  }
  request({
    url: '/aida-engine/appExecuteEngine/executeAllMethod',
    data: {data: param},
  })
    .then((res) => {
      if (loadingInstance) {
        loadingInstance.close();
      }
      tasks.forEach((v) => {
        // 处理成功后逻辑
        const item = res.find((p) => p.id === v.id);
        if (item && item?.response?.data) v.resolve(item.response.data);
        else v.resolve([]);
      });
    })
    .catch((err) => {
      if (loadingInstance) {
        loadingInstance.close();
      }
      console.warn(err);
      tasks.forEach((v) => {
        v.reject(null);
      });
    });
}

export default service
